module.exports = __webpack_public_path__ + "img/7_117.43def73c.png";